import {Suspense, lazy} from 'react';
import {AppLayout} from "../layout/AppLayout.tsx";
import {ReportsLoading} from "./ReportsLoading.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {ProductsLayout} from "../features/products/layout.tsx";
import {MeterReadingsLayout} from "../features/meter-readings/layout.tsx";
import {RatePlansLayout} from "../features/rate-plans/layout.tsx";
import {BillingProvidersLayout} from "../features/billing-providers/layout.tsx";

import {MetersLayout} from "../features/meters/layout.tsx";
import {PricesLayout} from "../features/prices/layout.tsx";
import {ActivityLogsLayout} from "../features/activity-logs/layout.tsx";
import {ProductFeaturesLayout} from "../features/product-features/layout.tsx";
import {ProviderMappingsLayout} from "../features/provider-mappings/layout.tsx";
import {ApplicationErrorPage} from "@flexinet/ui-components";
import {CustomersLayout} from "../features/customers/layout.tsx";
import {CustomerSubscriptionsLayout} from "../features/customer-subscriptions/layout.tsx";
import {DashboardLayout} from "../features/dashboard/layout.tsx";
import {InvoicesLayout} from "../features/invoices/layout.tsx";

// Lazy-loaded — keeps @mantine/charts + recharts (~166 kB gzip) out of the
// main bundle. Users only download the Reports chunk when navigating to /reports.
const ReportsLayout = lazy(() => import("../features/reports/layout.tsx"));


export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'dashboard',
        element: <DashboardLayout/>
    }, {
        path: 'products/*',
        element: <ProductsLayout/>
    }, {
        path: 'product-features/*',
        element: <ProductFeaturesLayout/>
    }, {
        path: 'prices/*',
        element: <PricesLayout/>
    }, {
        path: 'meter-readings/*',
        element: <MeterReadingsLayout/>
    }, {
        path: 'activity-logs/*',
        element: <ActivityLogsLayout/>
    }, {
        path: 'rate-plans/*',
        element: <RatePlansLayout/>
    }, {
        path: 'billing-providers/*',
        element: <BillingProvidersLayout/>
    }, {
        path: 'meters/*',
        element: <MetersLayout/>
    }, {
        path: 'customers/*',
        element: <CustomersLayout/>
    }, {
        path: 'customer-subscriptions/*',
        element: <CustomerSubscriptionsLayout/>
    }, {
        path: 'invoices/*',
        element: <InvoicesLayout/>
    }, {
        path: 'provider-mappings/*',
        element: <ProviderMappingsLayout/>
    }, {
        path: 'reports/*',
        element: (
            <Suspense fallback={<ReportsLoading/>}>
                <ReportsLayout/>
            </Suspense>
        )
    }]
}]